// The field vocabulary of the organization's settings, shared by the storage
// shape (./data), the public shape (./public), the api's model layer and the
// app. One settings row per organization, as there is one food log.
import { MEALS } from "../entry/fields";

export const orgId = { type: "string" };

// The meals turned OFF, not the ones turned on. A row saved before a fifth
// meal existed would otherwise hide it for ever; stored this way, a new meal
// shows until somebody turns it off. Never all of them: a food log with no
// meal has nowhere to put an entry, so at least one stays on.
export const hiddenMeals = {
  type: "array",
  items: { type: "string", enum: MEALS },
  uniqueItems: true,
  maxItems: MEALS.length - 1,
  default: [],
};

// What the settings screen sends: the meals to show, in any order.
export const meals = {
  type: "array",
  items: { type: "string", enum: MEALS },
  uniqueItems: true,
  minItems: 1,
};

// The meals on, in the order a day is eaten.
export const shownMeals = (hidden) => MEALS.filter((meal) => !(hidden || []).includes(meal));

// Where a meal goes when it is turned off: the nearest one that is on. Lunch
// falls back to a snack before breakfast, because something eaten at midday
// with no lunch to put it in is closer to a snack than to the morning.
const NEAREST = {
  breakfast: ["breakfast", "snack", "lunch", "dinner"],
  lunch: ["lunch", "snack", "dinner", "breakfast"],
  dinner: ["dinner", "snack", "lunch", "breakfast"],
  snack: ["snack", "lunch", "dinner", "breakfast"],
};

// `meal` if it is on, the nearest one on otherwise. An unknown meal is placed
// as a snack would be.
export const fitMeal = (meal, shown = MEALS) => {
  const order = NEAREST[meal] || NEAREST.snack;
  return order.find((m) => shown.includes(m)) || shown[0] || meal;
};
